<template>
    <div class="">
        <input id="input_copy" style="position: absolute;top: -100rem;"/>
        <div class="wechat">长按可保存图片</div>
        <!--        <a id="down" download><img src="" id="img" alt="" width="100%" @click="down"/></a>-->
        <img src="" id="img" alt="" width="100%"/>
        <canvas id="qrcode" v-show="false"></canvas>
        <canvas v-show="false" id="canvas"></canvas>

        <!-- 海报 -->
        <canvas v-show="false" id="myCanvas" width="" height=""></canvas>
        <a id="down2" class="down" download @click="click_save">
            <div class="img_92"></div>
        </a>

        <div class="img_91 copy cursor" @click="copy"></div>
    </div>
</template>

<script>

var QRious = require('./qrious.min')

module.exports = {
    props: ['data'],
    data() {
        return {
            img_bottom    : require('../../../img/lottery/bottom.png'),
            bg            : require('../../../img/40.png'), // 背景图
            ico_bg        : require('../../../img/lottery/216.png'), // 背景图
            creatCodeUrl  : 'xxxxxxxxxxxxxxxxxxxx',
            showSharePopup: false,
        }
    },
    mounted() {
        this.sharePopup()
    },
    methods: {
        click_save() {
            console.log('this.data', this.data.that.ok_task(3))
        },
        copy() {
            var url = window.location.href.split('?')[0] + '?shave_tel=' + encodeURIComponent(this.user_data.a_tel_shave)
            var input1 = document.querySelector("#input_copy")
            var real_num = '【冲破拘束，抓捕异常】《新月同行》公测预抽卡活动开启，招募5星特工，获取强力卡带，全副武装，共赴南廷！' + url
            input1.value = real_num;
            input1.select();
            document.execCommand("Copy");
            this.$top_box.show_box('复制成功')
            input1.blur();
            // 完成任务
            this.click_save()
            // alert('复制成功')
        },
        sharePopup() {
            this.showSharePopup = true;
            console.log('this.user_data', this.user_data)
            var url = window.location.href.split('?')[0] + '?shave_tel=' + encodeURIComponent(this.user_data.a_tel_shave)
            this.createQrcode(url, (src) => {
                this.data.role_img ? this.role_show(this.data.role_img, src) : this.drawAndShareImage(this.bg, src)
            })
        },
        closeSharePopup() {
            this.showSharePopup = false;
        },
        createQrcode(text, cb) {
            var img = new Image()
            var src = 'https://xytx.firewick.net/pub/qrcode?code=' + encodeURIComponent(text)

            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                console.log(img)
                cb(img)
            }
            img.src = src

        },
        save_img(canvas) {
            console.log('save_img')
            var base64 = canvas.toDataURL('image/png')

            let img = document.getElementById('img');
            img.setAttribute('src', base64)

            let down2 = document.getElementById('down2');
            down2.setAttribute('href', base64)
        },
        role_show(img1, img2) {
            var that = this
            let canvas = document.getElementById('myCanvas');
            canvas.width = 600;
            canvas.height = 1322;
            let context = canvas.getContext('2d');
            context.rect(0, 0, canvas.width, canvas.height);

            context.fill();
            let myImage = new Image();

            myImage.crossOrigin = 'Anonymous';
            myImage.onload = function () {
                var myImage2 = img2

                context.drawImage(myImage, -11, -11, 622, 1342);
                context.drawImage(myImage2, 432, 1157, 130, 130);
                that.save_img(canvas)

            };
            myImage.src = img1;
        },
        //img1背景图、img2二维码
        drawAndShareImage(img1, img2, role_img) {
            var that = this
            let canvas = document.getElementById('myCanvas');


            canvas.width = 600;
            canvas.height = 1322;
            let context = canvas.getContext('2d');
            context.rect(0, 0, canvas.width, canvas.height);

            context.fill();
            let myImage = new Image();

            myImage.crossOrigin = 'Anonymous';
            myImage.onload = function () {
                context.drawImage(myImage, 0, 0, 600, 1322);

                var myImage2 = img2

                context.drawImage(myImage2,425, 1150, 130, 130);
                if (!role_img) {
                    return that.save_img(canvas)
                }

                var myImage3 = new Image()
                myImage3.onload = function () {
                    context.drawImage(myImage3, -11, -11, 623, 1126);
                    that.save_img(canvas)
                }
                myImage3.src = role_img

            };
            myImage.src = img1;
        },
    }

}
</script>

<style scoped>
.down {
    position: absolute;
    bottom: -.3rem;
    left: 10%;
}

.copy {
    position: absolute;
    bottom: -.3rem;
    right: 10%;
}

#qrcode {
    position: absolute;
    left: 4.15rem;
    top: 0rem;
    width: 1.3rem;
    height: 1.3rem;

}

#down {
    width: 100%;
    height: 100%;
    display: block;
}

#qrcode >>> img {
    width: 100%;
}

.big_box.big_box.big_box.big_box {
    margin-top: -0.32rem;
    margin-left: -0.105rem;
    height: 10.22rem;
}
.wechat{
    position: absolute;
    text-align: center;
    left: 0rem;
    width: 100%;
    top: -0.3rem;
    color: #FFFFFF;
    font-size: 0.2rem;
}
</style>